import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { get } from 'api/requests';
import { loading } from 'store/common';

import { IReducer, AppThunk } from 'store/types';
import { INetworkCheckListState, NetworkCheckList } from 'features/EngineeringNetStatus/types';
import { IParamsReq } from 'types';

const initialState: INetworkCheckListState = {
  data: {} as NetworkCheckList,
  loading: false,
};

const reset: IReducer<INetworkCheckListState, INetworkCheckListState | null> = () => initialState;

const data: CaseReducer<INetworkCheckListState, PayloadAction<NetworkCheckList>> = (
  state,
  action,
) => {
  state.data = action.payload;
};

export const networkCheckListSlice = createSlice({
  name: 'CARDS/network_check_list',
  initialState,
  reducers: {
    loading: loading as IReducer<INetworkCheckListState, boolean>,
    data,
    reset,
  },
});

const {
  data: setNetworkCheckList,
  loading: setLoading,
  reset: setNetworkCheckListReset,
} = networkCheckListSlice.actions;

export const getNetworkCheckList =
  (networkId: number, params?: IParamsReq): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    get<NetworkCheckList>(
      `/api/v2/standards/check-list/get-check-list-network/${networkId}/`,
      params,
    )
      .then(({ data }) => {
        dispatch(setNetworkCheckList(data));
      })
      .finally(() => dispatch(setLoading(false)));
  };

export { setNetworkCheckListReset };
